<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
import { buildWhatsAppUrl } from '@/helpers/whatsapp'

export default {
  name: 'WhatsAppRedirect',
  computed: {
    ...mapGetters(['GET_DOMAIN']),
    whatsappId() {
      return this.$route.params.whatsappId
    }
  },
  async created() {
    try {
      const bot = await this.$store.dispatch('fetchWhatsappBotInformation', {
        whatsappBotId: this.whatsappId,
        domain: this.GET_DOMAIN
      })

      if (!bot) {
        this.$router.push({ path: '/whatsapp' }).catch(() => {})
        return
      }

      const redirectUrl = buildWhatsAppUrl(bot)

      // Automatically redirect to the WhatsApp link
      window.location.href = redirectUrl
    } catch (error) {
      console.error('Error fetching WhatsApp bot information:', error)
      this.$router.push({ path: '/whatsapp' }).catch(() => {})
    }
  }
}
</script>
